import { useEffect, useState } from "react";
import { IOrderStatus } from "../interfaces/order";
import { getStatusAliasList } from "../requests/orderRequests";
import { ORDER_STATUS } from "../utils/constants";

export const useSelectAliases = (selectedMarketplace: string) => {
  const [aliases, setAliases] = useState<IOrderStatus[]>([]);

  const getAliasesList = async () => {
    const response = await getStatusAliasList(selectedMarketplace);

    setAliases(
      ORDER_STATUS.map(({ label, id, ...rest }) => ({
        ...rest,
        id,
        label: response[id] || label,
      }))
    );
  };

  useEffect(() => {
    getAliasesList();
  }, [selectedMarketplace]);

  return { aliases };
};
